import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/agency',
      name: 'agency',
      component: () => import(/* webpackChunkName: "agnecy" */ './views/Agency.vue')
    },
    {
      path: '/program',
      name: 'program',
      component: () => import(/* webpackChunkName: "program" */ './views/Program.vue')
    },
    {
      path: '/providers',
      name: 'providers',
      component: () => import(/* webpackChunkName: "program" */ './views/Providers.vue')
    },
    //{
      //path: '/about',
      //name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      //component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    //}
  ]
})
